import {useEffect} from "react";
import {MAX_FETCH_DATA_SIZE, ResourceNames} from "../../config/const";
import {convertDataForSortableImage} from "../../common/image/databaseImageUtils";
import {CarModelImageProps} from "./CarModelImageComponent";

export const useCarModelImageHooks = (props: CarModelImageProps) => {

    useEffect(() => {
        const awaitFn = async () => {
            await getImages()
        };
        awaitFn().then();
    }, [props.carModelId])

    const getImages = async () => {
        if (props.carModelId) {
            const result = await convertDataForSortableImage(props.dataProvider,
                ResourceNames.CAR_MODEL_IMAGE_RESOURCE,
                {
                    pagination: {page: 1, perPage: MAX_FETCH_DATA_SIZE},
                    sort: {field: 'position', order: 'ASC'},
                    filter: {
                        carModelId: props.carModelId,
                    }
                }
            )
            props.setImages(result);
        }
    }

}
